export default __webpack_public_path__ + "./image/a276e52793d80175047e81b6576b342f.png";